














































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import AdminDepositShowTabular from '@/modules/deposit/components/admin/AdminDepositShowTabular.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import AdminDepositCreateForm from '@/modules/deposit/components/admin/AdminDepositCreateForm.vue'
import { TicketResourceType } from '@/modules/ticket/models/ticket-resource.model'
import AdminTicketShowTabular from '@/modules/ticket/components/admin/AdminTicketShowTabular.vue'
import AdminTicketSetting from '@/modules/ticket/components/admin/AdminTicketSetting.vue'
import AdminTicketNewAnswerForm from '@/modules/ticket-answer/components/admin/AdminTicketNewAnswerForm.vue'
import TicketAnswerList from '@/modules/ticket-answer/components/shared/TicketAnswerList.vue'
import NoteAddButton from '@/modules/common/note/components/admin/NoteAddCommentButton.vue'
import NoteAddCommentButton from '@/modules/common/note/components/admin/NoteAddCommentButton.vue'
import NoteCommentsViewer from '@/modules/common/note/components/admin/NoteCommentsViewer.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'تیکت'
  },
  metaInfo: {
    title: 'تیکت'
  },
  components: {
    NoteCommentsViewer,
    NoteAddCommentButton,
    NoteAddButton,
    TicketAnswerList,
    AdminTicketSetting,
    AdminTicketNewAnswerForm,
    AdminTicketShowTabular,
    AdminDepositCreateForm,
    CopyableText,
    TesDatePicker,
    BaseSelect,
    CurrencyInput,
    AdminDepositShowTabular,
    SimpleHeader,
    AdminUserInfoButton,
    BaseCard,
    BaseInput,
    BaseButton,
    PriceView,
    Toggle
  }
})
export default class ShowPage extends Vue {
  @Prop() ticketData!: TicketResourceType
  showAddCommentBtn = false
  showAddCommentModal = false

  private ticket: TicketResourceType = this.initData()

  initData() {
    return this.ticketData
  }
}
